module.exports = __webpack_public_path__ + "img/print.61a5ac14.svg";